import ServicePageTemplate from './ServicePageTemplate';
import { internshipProjectGuidanceModasaConfig } from './trainingPageConfigs';

const InternshipProjectGuidance = () => (
  <ServicePageTemplate {...internshipProjectGuidanceModasaConfig} />
);

export default InternshipProjectGuidance;
